import { useFormContext } from './form';
import GearV2 from '../../Vessels/Single/Rows/GearV2';
import GrabV2 from '../../Vessels/Single/Rows/GrabV2';
import React, { useContext } from 'react';
import GearedGrabbed from '../../Vessels/Single/Rows/GearedGrabbed';
import { orange500 } from 'material-ui/styles/colors';
import { InitialVesselRequirementsContext } from '../../Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements';

export const useInitialState = () => useContext(InitialVesselRequirementsContext);

const defaultGearV2 = {
    summary: [
        {
            type: null,
            quantity: null,
            capacity: null,
            outreach: null,
            maxSWL: null,
            combinable: false,
        },
    ],
};

const defaultGrabV2 = {
    summary: [
        {
            type: null,
            quantity: null,
            volume: null,
        },
    ],
};

export function FormGears() {
    const form = useFormContext();
    const initialState = useInitialState();

    return (
        <FormGearsOrGrabs
            title='GEAR:'
            isSetName='geared'
            onChangeIsSet={value => form.onChange([
                { field: 'geared', value },
                !value && { field: 'grabbed', value },
                !value && { field: 'gearV2', value: defaultGearV2 },
                !value && { field: 'grabV2', value: defaultGrabV2 },
            ])}
            name='gearV2'
            defaultValue={initialState.gearV2 || defaultGearV2}
            render={({ value, onChange }) => <GearV2 gearV2={value} changeField={onChange} fromTc />}
        />
    );
}

export function FormGrabs() {
    const form = useFormContext();
    const initialState = useInitialState();
    return (
        <FormGearsOrGrabs
            title='GRABS:'
            isSetName='grabbed'
            onChangeIsSet={value => form.onChange([
                { field: 'grabbed', value },
                !value && { field: 'grabV2', value: defaultGrabV2 },
            ])}
            name='grabV2'
            defaultValue={initialState.grabV2 || defaultGrabV2}
            render={({ value, onChange }) => <GrabV2 grabs={value} changeField={onChange} fromTc />}
        />
    );
}

const styles = {
    underlineStyle: {
        borderColor: orange500,
    },
};

function FormGearsOrGrabs({
    title, isSetName, onChangeIsSet, name, defaultValue, render,
}) {
    const form = useFormContext();

    return (
        <React.Fragment>
            <hr style={{ opacity: '0.2', marginTop: '20px' }} />
            <div className='row' style={{ height: '60px' }}>
                <div className='col-xs-1'>
                    <span className='name-block static huge-name'>{title}</span>
                </div>
                <div className="col-xs-3 col-xs-offset-8">
                    <GearedGrabbed
                        confirmed
                        modifiedFields={null}
                        fieldName={isSetName}
                        gearedGrabbed={form.values[isSetName]}
                        onChange={onChangeIsSet}
                        styles={styles}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-xs-12'>
                    {render({
                        value: form.values[name] || defaultValue,
                        onChange(changes) {
                            (Array.isArray(changes) ? changes : [changes]).forEach((change) => {
                                const fieldMatch = change.field.match(/\w+/);
                                if (!fieldMatch) return;

                                const field = fieldMatch[0];
                                const value = form.values[field] || defaultValue;
                                let newValue;

                                const match = change.field.match(/\[(\d+)\]\.(\w+)/);
                                if (match) {
                                    const index = +match[1];
                                    const prop = match[2];
                                    newValue = {
                                        ...value,
                                        summary: value.summary.map((item, i) =>
                                            (i === index
                                                ? { ...item, [prop]: change.value }
                                                : item)),
                                    };
                                } else {
                                    newValue = change.value;
                                }

                                form.onChange({
                                    field,
                                    value: newValue,
                                });
                            });
                        },
                    })}
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormGearsAndGrabs.jsx